'use strict';
require('../../widgets/gold-drive-import-widget');

const GoldDriveImportModel = require('../../models/gold-drive-import-model'),
	FormatConverter = require('../../models/format-converter'),
	RemoteImportController = require('../../models/remote-import-controller'),
	freemindImport = require('../../widgets/freemind-import'),
	mmWidgets = require('../../widgets/mm-widgets');

module.exports = function fileImportAwsStart(config, filePicker, subscriptionModel, navigatorShim, s3FileModel, configurationGenerator, storageApi, goldApi) {
	const remoteImportController = new RemoteImportController(configurationGenerator, storageApi, goldApi),
		importModel = new GoldDriveImportModel(config, filePicker, subscriptionModel, navigatorShim, s3FileModel, new FormatConverter(freemindImport), remoteImportController);

	return {
		importModel: importModel,
		initialiseWidgets: () => {
			mmWidgets('[data-mm-role~="import-widget"]').goldDriveImportWidget(importModel);
		}
	};

};
